import CardPost from "../../v2023/UI/Card/card-post"
import { NavCard } from "../../v2024/card"
import { Newsletter } from "../../v2024/newsletter"
import React from "react"

export const ResourcesSectionMobile = ({
    menuItem,
    title,
    items,
    newsletter,
    newsletterForm,
    lang,
    openMenuItem,
    selectOpenMenuItem,
    onLinkClick
}) => {
    const handleMenu = () => {
        selectOpenMenuItem(menuItem)
        document.getElementById("menuItem").scrollIntoView({ behavior: "smooth" })
    }

    return (
        <div id="menuItem" className={`item ${openMenuItem === menuItem ? "item--active" : ""}`}>
            <div className="item__header" onClick={() => handleMenu()}>
                <h6 className="item__header__title">{title}</h6>
                <i className="icon-chevron-down"></i>
            </div>
            <div className="item__body">
                {items.map((item, index) =>
                    <div className="mobile__menu__section">
                        <span className="section__title">{item.section_title}</span>
                        {item.section_items.map(element =>
                            <div key={element.url} onClick={onLinkClick}>
                                {index === 0 ?
                                    <CardPost
                                        key={index}
                                        name={element.title}
                                        description={element.description}
                                        image={element.image}
                                        horizontal
                                        url={element.url}
                                        size="sm"
                                    />
                                    :
                                    <NavCard
                                        title={element.title}
                                        link={element.url}
                                        icon={element.image}
                                        description={element.description}
                                        size="lg"
                                    />
                                }
                            </div>
                        )}
                    </div>
                )}
                <div className="mobile__menu__section mobile__menu__section--gray mobile__menu__section--newsletter">
                    <Newsletter
                        id="newsletter-menu-mobile"
                        lang={lang}
                        title={newsletter.title}
                        description={newsletter.description}
                        form={newsletterForm}
                    />
                </div>
            </div>
        </div>
    )
}